<template>
  <div v-if="!firstLoading" class="pb-1">
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <time-range-picker :model="filterFormModel" :label="$t('time')" :defaultShortcut="1"
                               class="mr-1"></time-range-picker>
            <button @click="load" class="btn btn-primary mr-1">{{ $t('search') }}</button>
          </div>
        </div>
      </div>
    </div>
    <div class="row text-center px-2">
      <div class="col-12">
        <h4 class="text-left text-primary mb-0">1. {{$t('call')}}</h4>
      </div>
      <div class="col-sm-6 col-lg-3 px-2 my-2">
        <div class="bg-white rounded py-4">
          <p class="mb-1">{{ $t('callMinute') }}</p>
          <h2 v-if="result" class="mb-3 mt-2 mb-lg-0">{{ result.callMinute | callDuration }}</h2>
          <h2 v-else class="mb-3 mt-2 mb-lg-0">{{ $t('notUpdated') }}</h2>
        </div>
      </div>
      <div class="col-sm-6 col-lg-3 px-2 my-2">
        <div class="bg-white rounded py-4">
          <p class="mb-1">{{ $t('callFee') }}</p>
          <h2 v-if="result" class="mb-3 mt-2 mb-lg-0">{{ result.callFee | numFormat }}</h2>
          <h2 v-else class="mb-3 mt-2 mb-lg-0">{{ $t('notUpdated') }}</h2>
        </div>
      </div>
      <div class="col-sm-6 col-lg-3 px-2 my-2">
        <div class="bg-white rounded py-4">
          <p class="mb-1">{{ $t('successCall') }}</p>
          <h2 v-if="result" class="mb-3 mt-2 mb-lg-0">{{ result.successCall | numFormat }}</h2>
          <h2 v-else class="mb-3 mt-2 mb-lg-0">{{ $t('notUpdated') }}</h2>
        </div>
      </div>
      <div class="col-sm-6 col-lg-3 px-2 my-2">
        <div class="bg-white rounded py-4">
          <p class="mb-1">{{ $t('underTwentySecondRate') }}</p>
          <h2 v-if="result" class="mb-3 mt-2 mb-lg-0">
            {{ result.totalCall ? (result.successCall20s / result.successCall) * 100 : 0 | numFormat('0.0') }}%
          </h2>
          <h2 v-else class="mb-3 mt-2 mb-lg-0">{{ $t('notUpdated') }}</h2>
        </div>
      </div>
    </div>
    <div class="row text-center px-2 mt-2">
      <div class="col-12">
        <h4 class="text-left mb-0 text-primary">2. {{$t('opportunity')}}</h4>
      </div>
      <div class="col-sm-6 col-lg-3 px-2 my-2">
        <div class="bg-white rounded py-4">
          <p class="mb-1">{{ $t('opportunityCreated') }}</p>
          <h2 v-if="result" class="mb-3 mt-2 mb-lg-0">{{ result.opportunityCreated | numFormat }}</h2>
          <h2 v-else class="mb-3 mt-2 mb-lg-0">{{ $t('notUpdated') }}</h2>
        </div>
      </div>
      <div class="col-sm-6 col-lg-3 px-2 my-2">
        <div class="bg-white rounded py-4">
          <p class="mb-1">{{ $t('opportunityUpdated') }}</p>
          <h2 v-if="result" class="mb-3 mt-2 mb-lg-0">{{ result.opportunityUpdated | numFormat }}</h2>
          <h2 v-else class="mb-3 mt-2 mb-lg-0">{{ $t('notUpdated') }}</h2>
        </div>
      </div>
    </div>
    <div class="row text-center px-2 mt-2">
      <div class="col-12">
        <h4 class="text-left text-primary mb-0">3. {{$t('callCampaign')}}</h4>
      </div>
      <div class="col-sm-6 col-lg-3 px-2 my-2">
        <div class="bg-white rounded py-4">
          <p class="mb-1">{{ $t('callCampaignCreated') }}</p>
          <h2 v-if="result" class="mb-3 mt-2 mb-lg-0">{{ result.callCampaignCreated | numFormat }}</h2>
          <h2 v-else class="mb-3 mt-2 mb-lg-0">{{ $t('notUpdated') }}</h2>
        </div>
      </div>
      <div class="col-sm-6 col-lg-3 px-2 my-2">
        <div class="bg-white rounded py-4">
          <p class="mb-1">{{ $t('callCampaignUpdated') }}</p>
          <h2 v-if="result" class="mb-3 mt-2 mb-lg-0">{{ result.callCampaignUpdated | numFormat }}</h2>
          <h2 v-else class="mb-3 mt-2 mb-lg-0">{{ $t('notUpdated') }}</h2>
        </div>
      </div>
    </div>
    <div class="row text-center px-2 mt-2">
      <div class="col-12">
        <h4 class="text-left text-primary mb-0">4. {{$t('ticket')}}</h4>
      </div>
      <div class="col-sm-6 col-lg-3 px-2 my-2">
        <div class="bg-white rounded py-4">
          <p class="mb-1">{{ $t('ticketCreated') }}</p>
          <h2 v-if="result" class="mb-3 mt-2 mb-lg-0">{{ result.ticketCreated | numFormat }}</h2>
          <h2 v-else class="mb-3 mt-2 mb-lg-0">{{ $t('notUpdated') }}</h2>
        </div>
      </div>
      <div class="col-sm-6 col-lg-3 px-2 my-2">
        <div class="bg-white rounded py-4">
          <p class="mb-1">{{ $t('ticketUpdated') }}</p>
          <h2 v-if="result" class="mb-3 mt-2 mb-lg-0">{{ result.ticketUpdated | numFormat }}</h2>
          <h2 v-else class="mb-3 mt-2 mb-lg-0">{{ $t('notUpdated') }}</h2>
        </div>
      </div>
    </div>
    <div class="row text-center px-2 mt-2">
      <div class="col-12">
        <h4 class="text-left text-primary mb-0">5. {{$t('other')}}</h4>
      </div>
      <div class="col-sm-6 col-lg-3 px-2 my-2">
        <div class="bg-white rounded py-4">
          <p class="mb-1">{{ $t('totalKpi') }}</p>
          <h2 v-if="result" class="mb-3 mt-2 mb-lg-0">{{ result.totalKpi | numFormat }}</h2>
          <h2 v-else class="mb-3 mt-2 mb-lg-0">{{ $t('notUpdated') }}</h2>
        </div>
      </div>
      <div class="col-sm-6 col-lg-3 px-2 my-2">
        <div class="bg-white rounded py-4">
          <p class="mb-1">{{ $t('totalAutomation') }}</p>
          <h2 v-if="result" class="mb-3 mt-2 mb-lg-0">{{ result.totalAutomation | numFormat }}</h2>
          <h2 v-else class="mb-3 mt-2 mb-lg-0">{{ $t('notUpdated') }}</h2>
        </div>
      </div>
      <div class="col-sm-6 col-lg-3 px-2 my-2">
        <div class="bg-white rounded py-4">
          <p class="mb-1">{{ $t('activeUser') }}</p>
          <h2 v-if="result" class="mb-3 mt-2 mb-lg-0">{{ result.activeUser | numFormat }}</h2>
          <h2 v-else class="mb-3 mt-2 mb-lg-0">{{ $t('notUpdated') }}</h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TimeRangePicker from "@/components/TimeRangePicker";
import moment from "moment";

export default {
  props: ['client'],
  components: {TimeRangePicker},
  data() {
    return {
      result: null,
      firstLoading: true,
      filterFormModel: {
        client: this.client ? this.client._id : null,
        from: moment().subtract('1', 'day').startOf('day').valueOf(),
        to: moment().subtract('1', 'day').endOf('day').valueOf(),
      },
    }
  },
  methods: {
    load() {
      let loader = this.$loading.show();
      this.$bgService.get('/client-care-report', {params: this.filterFormModel}).then(response => {
        if (response && response.data) {
          this.result = response.data;
        }
      }).finally(() => {
        loader.hide();
        this.firstLoading = false;
      })
    }
  },
  mounted() {
    this.load();
  },
  i18n: {
    messages: {
      en: {
        callMinute: 'Số phút gọi',
        callFee: 'Doanh thu cuớc',
        activeUser: 'Số user active',
        successCall: 'Cuộc gọi thành công',
        underTwentySecondRate: 'Tỷ lệ cuộc gọi dưới 20 giây',
        totalAutomation: 'Tự động hoá',
        totalKpi: "KPI",
      },
      vi: {
        callMinute: 'Số phút gọi',
        callFee: 'Doanh thu cuớc',
        activeUser: 'Số user active',
        successCall: 'Cuộc gọi thành công',
        underTwentySecondRate: 'Tỷ lệ cuộc gọi dưới 20 giây',
        totalAutomation: 'Tự động hoá',
        totalKpi: "KPI",
        opportunityCreated: "Cơ hội bán hàng được tạo mới",
        opportunityUpdated: "Cơ hội bán hàng được cập nhật",
        callCampaignCreated: "Chiến dịch gọi được tạo mới",
        callCampaignUpdated: "Chiến dịch gọi được cập nhật",
        ticketCreated: "Ticket được tạo mới",
        ticketUpdated: "Ticket được cập nhật",
        call: "Cuộc gọi",
        opportunity: "Cơ hội bán hàng",
        callCampaign: "Chiến dịch gọi" ,
        ticket: "Ticket",
      }
    }
  },
}
</script>
